// import moment from 'moment'
import { flatMap } from 'lodash-es'

// import { momentFormat } from '~/plugins/filters'

import {
  // PAGINATION_KIND_ONE_QUESTION_BY_PAGE,
  PAGINATION_KIND_GROUP_QUESTIONS_BY_PAGE,
  QUESTION_KIND_FREE_TEXT,
  QUESTION_KIND_MULTIPLE_CHOICE,
  QUESTION_KIND_RATINGS,
  STYLE_STANDARD,
  STYLE_RECTANGLE_CHOICES,
  STYLE_TEXT_AND_OR_IMAGE,
  STYLE_TEXT_AND_OR_BIG_IMAGE
} from '@/utils/constants/quizzes.ts'

function htmlStyleClassFromStyle(style) {
  switch (style) {
    case STYLE_STANDARD:
    case STYLE_RECTANGLE_CHOICES:
      return
    case STYLE_TEXT_AND_OR_IMAGE:
      return 'textAndOrImage'
    case STYLE_TEXT_AND_OR_BIG_IMAGE:
      return 'textAndOrImage textAndOrBigImage'
  }
}

// max size for 375px wide phone
// (ex: iphone SE / 5S)
const IMAGE_WIDTH = 320

export const pagesCount = (state) =>
  state.modified && state.modified.pages.length

export const isMultiplePages = (state) =>
  state.modified &&
  state.modified.paginationKind === PAGINATION_KIND_GROUP_QUESTIONS_BY_PAGE

export const hasMoreThanOnePage = (state) =>
  state.modified && state.modified.pages.length > 1

export const payloadForBackend = (state) => {
  const res = {
    attributes: {
      started_at: state.modified.startedAt?.toISOString(),
      ended_at: state.modified.endedAt?.toISOString(),
      benefits: {},
      data: {
        identifier: state.modified.identifier,
        timeline_title: state.modified.timelineTitle,
        timeline_content: state.modified.timelineContent,
        image_url: state.modified.timelineImageUrl,
        image_file: state.modified.timelineImageFile,
        skip_intro_page: state.modified.skipIntroPage,
        everyone_wins: state.modified.everyoneWins,
        suggest_product_from_tastes: state.modified.suggestProductFromTastes,
        is_survey: state.modified.isSurvey,
        skip_logo: state.modified.skipLogo,
        header_image_url: state.modified.headerImageUrl,
        header_image_file: state.modified.headerImageFile,
        // TODO: should be refactored on the backend
        html_style_class: htmlStyleClassFromStyle(state.modified.generalStyle),
        display_rectangle_choices:
          state.modified.generalStyle === STYLE_RECTANGLE_CHOICES
      }
    }
  }

  if (state.modified.timelineImageSizes) {
    res.attributes.data.timeline_picture_data = {
      width: IMAGE_WIDTH,
      height: Math.round(
        (IMAGE_WIDTH * state.modified.timelineImageSizes.height) /
          state.modified.timelineImageSizes.width
      )
    }
  } else if (state.modified.timelinePictureData) {
    res.attributes.data.timeline_picture_data =
      state.modified.timelinePictureData
  }

  const relevantQuestions =
    state.modified.paginationKind === PAGINATION_KIND_GROUP_QUESTIONS_BY_PAGE
      ? flatMap(state.modified.pages, (page) => page.questions)
      : state.modified.pages[0].questions

  res.attributes.data.questions = relevantQuestions.map((question) => {
    const desc = {
      question: question.title,

      answers: question.answers.map((answer) => answer.text),
      answers_images: question.answers.map((answer) => ({
        image_url: answer.imageUrl,
        image_file: answer.imageFile
      })),
      correct_answer_index: question.correctAnswerIndex,

      min_choice_count: question.minChoiceCount,
      max_choice_count: question.maxChoiceCount,
      min_rating: question.minRating,
      max_rating: question.maxRating,

      image_url: question.imageUrl,
      image_file: question.imageFile,

      very_big_text: question.veryBigText,
      hide_text: question.hideText,
      is_survey: question.isSurvey
    }
    switch (question.kind) {
      case QUESTION_KIND_FREE_TEXT:
        desc.free_text = true
        break
      case QUESTION_KIND_RATINGS:
        desc.ratings = true
        break
      case QUESTION_KIND_MULTIPLE_CHOICE:
      // nothing needed
    }
    return desc
  })

  if (
    state.modified.paginationKind === PAGINATION_KIND_GROUP_QUESTIONS_BY_PAGE
  ) {
    res.attributes.data.question_pages = state.modified.pages.map((page) => ({
      title: page.title,
      count: page.questions.length
    }))
  }

  if (state.modified.hasRefundBenefit) {
    res.attributes.benefits.refund_identifier =
      state.modified.refundBenefitIdentifier
  }
  if (state.modified.hasBonusBenefit) {
    res.attributes.benefits.bonus_identifier =
      state.modified.bonusBenefitIdentifier
  }
  if (state.modified.hasPointsBenefit) {
    res.attributes.benefits.points = state.modified.pointsBenefitCount
  }

  return res
}
